import "./ProductSection.scss";

import React from "react";
import { useTranslation } from "react-i18next";

import ApplianceSingle from "./ApplianceSingle";
import { AllProductsNodeModel } from "../../models/allProductsNodeModel";

type ProductSectionProps = {
    elements: AllProductsNodeModel[];
    isDiscontinued?: boolean;
};

export default function ProductSection(props: ProductSectionProps) {
    const { elements, isDiscontinued = false } = props;
    const { t } = useTranslation("pages");

    return (
        <div className={isDiscontinued ? "discontinued-section" : "product-section"}>
            <h2>{isDiscontinued ? t("search.discontinued-products") : t("search.products")}</h2>
            <div className="product-grid">
                {elements.map((product: AllProductsNodeModel, index: number) => {
                    return (
                        <ApplianceSingle
                            appliance={product}
                            key={
                                isDiscontinued
                                    ? `discontinued-appliance-${index}`
                                    : `active-appliance-${index}`
                            }
                            isDiscontinued={
                                isDiscontinued ||
                                product.live?.currentStock.status == "discontinued" ||
                                product.live === undefined
                            }
                        />
                    );
                })}
            </div>
        </div>
    );
}
